import React from 'react';

import { sendRequest, triggerEvent } from '../../helpers/global.js';

import TextInput from '../input/TextInput';

import '../../sass/components/SettingsView.scss';

class EditPasswordView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        old_password: '',
        new_password: '',
        repeat_password: '',
      },
      errors: {},
    }
  }

  onSave = () => {
    const data = this.state.data;
    let errors = {};
    if (!data.old_password) {
      errors.old_password = 'Password is required';
    }
    if (!data.new_password) {
      errors.new_password = 'Password is required';
    } else {
      const minLength = data.new_password.length >= 8;
      const oneNumber = data.new_password.match(/\d/);
      const oneUppercase = data.new_password.match(/[A-Z]/);
      const oneSpecial = data.new_password.match(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/);
      if (!minLength || !oneNumber || !oneUppercase || !oneSpecial) {
        errors.new_password = 'Password must have: Minimum 8 characters, one number, one special character, one uppercase letter';
      }
    }
    if (data.new_password !== data.repeat_password) {
      console.log(data.new_password, data.repeat_password)
      errors.repeat_password = 'Passwords do not match';
    }
    this.setState({errors});
    if (Object.keys(errors).length > 0) {
      return;
    }
    sendRequest({
      method: 'me/password',
      type: 'PUT',
      data: {
        old_password: data.old_password,
        password: data.new_password,
      },
      success: (data) => {
        this.setState({
          data: {
            old_password: '',
            new_password: '',
            repeat_password: '',
          }
        });
        triggerEvent('showSnackbar', [{text: 'Password updated', type: 'success'}]);
      },
      error: (data) => {
        if (data.errors) {
          this.setState({errors: data.errors});
        }
      }
    });
  }

  renderInputBlock = (key, title, type = 'text') => {
    return (
      <div className='inputBlock'>
        <label>{title}</label>
        <TextInput
          properties={{type}}
          object={this.state.data[key]}
          onChange={(k, val) =>
            this.setState({
              data: {
                ...this.state.data,
                [key]: val,
              },
            })
          }
          error={this.state.errors[key]}
        />
      </div>
    )
  }

  render = () => {
    const filled = Object.keys(this.state.data).reduce(
      (res, key) => res && this.state.data[key]
    , true);
    return (
      <div className='settingsBlock'>
        <div className='blockTitle'>Change password</div>
        {this.renderInputBlock('old_password', 'Current password', 'password')}
        {this.renderInputBlock('new_password', 'New password', 'password')}
        {this.renderInputBlock('repeat_password', 'Confirm new password', 'password')}
        <button
          onClick={this.onSave}
          disabled={!filled}
        >Save Changes</button>
      </div>
    )
  }
}

export default EditPasswordView;
